export let unreadMessageCount = 0;

function openMessages() {
    if (window.location.href.includes('/account#messages')) {
        fetchMessages();
        return;
    } else if (window.location.href.includes('/account')) {
        window.location.hash = '#messages';
        return;
    }
    window.location.href = '/account#messages';
}

export function displayUnreadMessages() {
    const unreadMessageCountEl = document.getElementById('unread-messages-count');
    const unreadMessages = document.getElementById('notificationsOverview');

    if (unreadMessageCount < 0) {
        unreadMessageCount = 0;
    }

    if (unreadMessageCountEl) {
        unreadMessageCountEl.innerHTML = unreadMessageCount;

        if (unreadMessageCount == 0) {
            unreadMessageCountEl.classList.add('hidden');
        } else {
            unreadMessageCountEl.classList.remove('hidden');
        }
    }

    if (unreadMessageCount > 0 && unreadMessages) {
        unreadMessages.innerHTML = t('msg.some', { count: unreadMessageCount });
    }

    if (typeof updateFriendsCount === 'function') {
        updateFriendsCount();
    }
}